import { Component, HostBinding, inject, OnDestroy, OnInit } from '@angular/core';
import { AppInfoService, AuthService, ScreenService, ThemeService } from './services';
import { RouterOutlet } from '@angular/router';
import { DxLoadPanelModule } from 'devextreme-angular';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>
    <dx-load-panel
      container=".layout-body"
      [visible]="isLoading()"
      [shading]="false"
      [message]="'Please wait...'"
      [showPane]="false"
      [position]="{ of: 'screen' }"
    >
    </dx-load-panel>
  `,
    styles: [
        `
      @use '../variables.scss' as *;

      :host {
        background-color: var(--side-panel-background);
        display: flex;
        height: 100%;
        width: 100%;
      }
    `
    ],
    imports: [RouterOutlet, DxLoadPanelModule]
})
export class AppComponent implements OnDestroy {
  screen = inject(ScreenService);
  appInfo = inject(AppInfoService);

  isLoading = this.appInfo.isLoading;

  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      .filter((cl) => this.screen.sizes[cl])
      .join(' ');
  }

  constructor(themeService: ThemeService) {
    themeService.setAppTheme();
  }

  ngOnDestroy(): void {
    this.screen.breakpointSubscription.unsubscribe();
  }
}
